import * as React from 'react';
import { Checkbox, Spacer } from '@smartsheet/lodestar-core';
import { MAX_FILTER_NAME } from '../../../common/constants';
import { AccessLevel } from '../../../common/enums';
import { AutomationIds } from '../../../common/enums/AutomationElements.enum';
import { FilterUI } from './types';
import { Filter } from '../../../common/classes/Filter/Filter';
import { Column } from '../../../common/interfaces';
import { useLanguageElements } from '../../../language-elements/withLanguageElementsHOC';
interface FilterNameInputProps {
    filter: FilterUI;
    currentUserAccessLevel: AccessLevel;
    fields: Column[];
    onFilterUpdate: (updatedFilter: FilterUI) => void;
    onSetActiveCondition: (index: number) => void;
    onSetShowErrors: (showErrors: boolean) => void;
}

const FilterNameInput: React.FC<FilterNameInputProps> = ({
    filter,
    currentUserAccessLevel,
    fields,
    onFilterUpdate,
    onSetActiveCondition,
    onSetShowErrors,
}) => {
    const showCheckbox = currentUserAccessLevel === AccessLevel.OWNER || currentUserAccessLevel === AccessLevel.ADMIN;
    const languageElements = useLanguageElements();
    const handleChangeFilterName = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const updatedFilter = new Filter(fields, filter, false);
        updatedFilter.changeName(e.target.value);
        onSetActiveCondition(-1);
        onFilterUpdate(updatedFilter.toDisplayModel());
        onSetShowErrors(false);
    };

    const handleChangeShareStatus = (): void => {
        const updatedFilter = new Filter(fields, filter, false);
        updatedFilter.setSharing(!updatedFilter.shared);
        onFilterUpdate(updatedFilter.toDisplayModel());
    };

    return (
        <div className={'filter-name-container'}>
            <p>
                {languageElements.ADHOC_FILTER_NAME_PROMPT}
                <span>{languageElements.ADHOC_FILTER_OPTIONAL}</span>
            </p>
            <div className={'flex-row'}>
                <div className={`user-input ${showCheckbox ? 'show-checkbox' : ''}`}>
                    <input
                        type="text"
                        maxLength={MAX_FILTER_NAME}
                        onChange={handleChangeFilterName}
                        value={filter && filter.name ? filter.name : ''}
                        data-client-id={AutomationIds.FILTER_NAME}
                    />
                </div>
                {showCheckbox && (
                    <Spacer orientation="row" size="medium">
                        <Checkbox
                            checkedState={Boolean(filter && filter.shared) ? 'checked' : 'unchecked'}
                            onClick={handleChangeShareStatus}
                            label={languageElements.ADHOC_FILTER_SHARE}
                            inputId={filter && filter.id ? filter.id : 'new'}
                            clientId={AutomationIds.FILTER_SHARE_CHECKBOX}
                        />
                    </Spacer>
                )}
            </div>
        </div>
    );
};

export default FilterNameInput;
